// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ErrorApiDefaultMessage } from "@vanmeter/XDL/constants";

const brandTargetsUri = "/api/vmi/brands/brandTargets";
const categoryTargetsUri = "/api/vmi/category/categoryTargets";

export async function getBrandTargets(): Promise<ServiceResult<string[]>> {
    try {
        const res = await get<string[]>(brandTargetsUri);
        return {
            result: res,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error?.errorJson?.message || error?.message || ErrorApiDefaultMessage,
        };
    }
}

export async function getCategoriesTargets(): Promise<ServiceResult<string[]>> {
    try {
        const res = await get<string[]>(categoryTargetsUri);
        return {
            result: res,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error?.errorJson?.message || error?.message || ErrorApiDefaultMessage,
        };
    }
}
